import { render, staticRenderFns } from "./DialogPayments.vue?vue&type=template&id=772e320e&"
import script from "./DialogPayments.vue?vue&type=script&lang=js&"
export * from "./DialogPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports